import { RepliesItem } from "@skylead/component-library"
import React from "react"
import { useDispatch, useSelector } from "react-redux"

import * as actions from "../../../redux/actions"
import { updateFormField, updateFormFields } from "../../../redux/actions"
import { store } from "../../../redux/store"
import { getAllSavedReplies } from "../../../redux/user/userActions"
import dataUtils from "../../../utils/data/data-utils"
import { useGlobalTranslation } from "../../../utils/hook"
import { removeEmojiTitlesFromLeadName } from "../../../utils/label-utils"
import { cleanMessage, validateCreateSavedReply } from "../../../utils/validation/validation-utils"
import StepCardVariableSelector from "../../organisms/StepCardVariableSelector"

const SavedReply = ({
  showModal,
  setShowModal,
  disableChat = false,
  manualEmail = false,
  isEmail = true,
}) => {
  const dispatch = useDispatch()
  const { tt } = useGlobalTranslation()

  const [
    { savedReplyTitle, savedReplyText, loadingSavedReply },
    allSupportedTags,
    additionalVariables,
    allSavedReplies,
    linkedinUser,
    formErrors,
    isEuropeanFormat,
  ] = useSelector(state => [
    state.forms.formData,
    state.app.allSupportedTags,
    state.campaign.additionalVariables,
    state.user.savedReplies,
    state.user.linkedinUserData.linkedinUser,
    state.forms.formErrors,
    state.app.isEuropeanFormat,
  ])

  const updateFormHorizon = (fieldOrFields, valueToUpdate) => {
    if (typeof fieldOrFields === "object") {
      dispatch(updateFormFields(fieldOrFields))
    } else {
      dispatch(updateFormField(fieldOrFields, valueToUpdate))
    }
  }

  const deleteSavedReply = savedReplyId => {
    dispatch(actions.deleteSavedReply(tt, savedReplyId))
  }

  const setFormErrors = allErrors => {
    dispatch(actions.setFormErrors(allErrors))
  }

  const createSavedReply = formData => {
    dispatch(actions.crateSavedReply(tt, formData.savedReplyTitle, formData.savedReplyText))
  }

  const editSavedReply = () => {
    dispatch(
      actions.editSavedReply(
        tt,
        store.getState().forms.formData.savedReplyTitle,
        store.getState().forms.formData.savedReplyText,
        store.getState().forms.formData.savedReplyId,
      ),
    )
  }

  const handleGetAllSavedReplies = async () => {
    dispatch(updateFormField("loadingSavedReply", true))
    setShowModal(state => !state)
    await dispatch(getAllSavedReplies())
    dispatch(updateFormField("loadingSavedReply", false))
  }

  const selectSavedReplyMessage = () => {
    const formField = manualEmail ? "manualEmailMessage" : "chatMessage"
    const message = store.getState().forms.formData[formField] || ""
    return { message, formField }
  }

  const clearFormError = field => {
    dispatch(actions.clearFormError(field))
  }

  return (
    <RepliesItem
      updateFormHorizon={updateFormHorizon}
      tt={tt}
      handleGetAllSavedReplies={handleGetAllSavedReplies}
      editSavedReply={editSavedReply}
      setFormErrors={setFormErrors}
      formData={store.getState().forms.formData}
      deleteSavedReply={deleteSavedReply}
      loadingSavedReply={loadingSavedReply}
      savedReplyText={savedReplyText}
      savedReplyTitle={savedReplyTitle}
      allSupportedTags={allSupportedTags}
      additionalVariables={additionalVariables}
      allSavedReplies={allSavedReplies}
      dataUtils={dataUtils}
      removeEmojiTitlesFromLeadName={removeEmojiTitlesFromLeadName}
      linkedinUser={linkedinUser}
      searchFilter={store.getState().forms.formData["search-saved-replies"] || ""}
      cleanMessage={cleanMessage}
      validateCreateSavedReply={validateCreateSavedReply}
      showModal={showModal}
      disableChat={disableChat}
      manualEmail={manualEmail}
      isEmail={isEmail}
      setShowModal={setShowModal}
      StepCardVariableSelector={StepCardVariableSelector}
      selectSavedReplyMessage={selectSavedReplyMessage}
      formErrors={formErrors}
      createSavedReply={createSavedReply}
      clearFormError={clearFormError}
      isEuropeanFormat={isEuropeanFormat}
    />
  )
}

// SavedReply.propTypes = {
//   disableChat: PropTypes.bool,
//   showModal: PropTypes.bool.isRequired,
//   setShowModal: PropTypes.func.isRequired,
//   isEmail: PropTypes.bool,
//   manualEmail: PropTypes.bool,
// }

export default SavedReply
